//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pluginCard from '~/components/card/like-card.vue';
import mgVideo from '~/components/custom/mg-video.vue';
import avatar from '@/components/avatar.vue';
import UsePluginDropdown from '@/components/plugin/use-plugin-dropdown.vue';
import { setting_obj } from '@/settings/setting';
import { diffTime, formatPath, kFormatter, dfsTransformXssKeys } from '~/utils/tools';
import { pluginApiUrlMap } from '@/api/url';
import { handlePraise, downloadApi } from '@/utils/userTools';
import { isMobile } from '@/utils/constants';
import { handleUserBehaviorByType } from '@/components/subscription/subscription.js';
import { getPluginTDK } from '@/api/cms';
import { giveInstallMessage } from '@/utils/pluginMessage';

const xss = require('xss');

let isClick = false;
export default {
  components: {
    avatar,
    pluginCard,
    mgVideo,
    UsePluginDropdown,
  },
  data() {
    return {
      FileType: {
        DEV: 0,
        PROTOTYPE: 1,
      },
      recentFiles: [],
      fileDialogVisible: false,
      copyUrl: '',
      pluginInfo: {},
      iframeObj: {
        fileUrl: '',
        coverUrl: '',
        width: '',
        height: '',
        border: '8px',
        showZoomButton: true,
        showProgressBar: false,
      },
      likeList: [],
      labels: ['Button', '设计系统', 'Ant', 'Antd', 'Components', 'Design System', '组件库', '组件'],
      isSelf: false,
      loading: false,
      showMore: false,
      showMoreDesc: false,
      showLabelTips: false,
      plugin_html: '',
    };
  },
  async asyncData({ app, params, redirect }) {
    const id = +params.id;
    const requestUrl = pluginApiUrlMap.getPluginDetail;
    const backData = {
      plugin_id: id,
    };
    try {
      const pluginSeoTDKPromise = getPluginTDK(id, app.$axios);
      const { data } = await app.$axios.$get(requestUrl, {
        params: {
          plugin_id: id,
        },
      });
      const pluginSeoTDKInfo = await pluginSeoTDKPromise;
      app.head.title = pluginSeoTDKInfo?.title || `${data.plugin_name}-MasterGo 社区`;
      const pluginInfo = data;
      if (pluginInfo && pluginInfo.version_desc) {
        pluginInfo.version_desc.forEach((version) => {
          version.issue_time = app.$dayjs(version.issue_time).format('YYYY年M月DD日');
        });
      }
      backData.pluginInfo = pluginInfo;
      try {
        const plugin_cata = pluginInfo?.plugin_cata?.join(',') || '';
        const likeUrl = pluginApiUrlMap.getGuessLikePlugins;
        const resLike = await app.$axios.$post(likeUrl, {
          cata_names: plugin_cata,
          cur_plugin_id: id,
        });
        backData.likeList = resLike.data || [];
        return backData;
      } catch {
        return backData;
      }
    } catch (e) {
      console.log('err', e);
      if (e?.response?.status === 404) {
        return redirect('/404/plugin');
      }
      return backData;
    }
  },
  computed: {
    updateTime() {
      const time = this.pluginInfo.create_time;
      return time ? diffTime(new Date(time).getTime()) : '暂无时间';
    },
    canUsePlugin() {
      return this.pluginInfo.is_install && this.rencentSixFiles.length > 0;
    },
    isDevModePlugin() {
      return this.pluginInfo.editor_type === 'devMode';
    },
  },
  created() {},
  mounted() {
    if (!isMobile()) {
      this.showLabelTips = !window.localStorage.getItem('SHOWED_LABEL_TIPS');
    }
    if (this.showLabelTips) {
      setTimeout(() => {
        window.localStorage.setItem('SHOWED_LABEL_TIPS', 1);
      }, 1000);
    }
    this.copyUrl = location.href;
    this.formatData();
    this.$nextTick(() => {
      const top = this.$refs.version?.offsetHeight || 0;
      const desc_top = this.$refs.desc?.offsetHeight || 0;
      this.showMoreDesc = desc_top > 640;
      this.showMore = top > 640 || this.pluginInfo.version_desc?.length >= 3;
    });
    const { from, r_index } = this.$route.query || {};
    if (from === 'plugin_popup') {
      const sensorParams = {
        action_position: from,
        plugin_id: this.pluginInfo.plugin_id,
        plugin_name: this.pluginInfo.plugin_name,
      };
      if (r_index) {
        sensorParams.action_detail = r_index;
      }
      // 根据来源增加访问社区文件埋点
      this.$sensors.track('get_plugin', sensorParams);
    }
    const userInfo_id = this.$store?.state?.user?.userInfo?.id;
    let { author_id } = this.pluginInfo;
    author_id = author_id ? `${author_id}` : '';
    this.isSelf = String(userInfo_id) === String(author_id);

    // 添加访问插件详情的卖点埋点
    const sensorParams = {
      action_position: 'plugin_page_detail',
      plugin_id: this.pluginInfo.plugin_id,
      plugin_name: this.pluginInfo.plugin_name,
      action_detail: this.action_detail,
    };
    this.$sensors.track('page_view', sensorParams);
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    setPluginData() {
      localStorage.setItem(
        'temporary_community_openfile_data',
        JSON.stringify({
          pluginId: this.pluginInfo.plugin_id,
          devMode: this.isDevModePlugin,
        }),
      );
    },
    async openFile(item) {
      try {
        // 第一步：获取邀请ID
        const inviteResponse = await this.$axios.$post(`${window.location.origin}/api/v1/project/link-invite`, {
          documentId: item.id,
        });

        const { inviteDataId, inviteBatchId } = inviteResponse.data;
        const filePrefix = item.fileMode === this.FileType.DEV ? 'file' : 'prototyping';

        // 第二步：获取短链接
        const longUrl = `${window.location.origin}/${filePrefix}/${item.id}?inviteDocumentId=${inviteDataId}&inviteBatchId=${inviteBatchId}`;

        const shortlinkResponse = await this.$axios.$post(`${window.location.origin}/api/v1/tools/shortlink`, {
          url: longUrl,
          reserved: `file=${item.id}`,
        });

        // 在新标签页打开文件
        this.setPluginData();
        window.open(shortlinkResponse.data.shortUrl, '_blank');
      } catch (error) {
        this.$message.error('文件打开失败，请重试');
      }
    },
    createFile(type) {
      this.setPluginData();
      window.open(
        `${window.location.origin}/files/home?action=create&fileMode=${type}&pluginId=${this.pluginInfo.plugin_id}`,
      );
    },
    closeGuide() {
      this.showLabelTips = false;
    },
    kFormatter,
    formatData() {
      if (!this.pluginInfo) return;
      dfsTransformXssKeys(this.pluginInfo);
      const data = { ...this.pluginInfo };
      ['plugin_logo', 'plugin_cover_url', 'author_avatar'].forEach((key) => {
        if (data[key]) {
          data[key] = formatPath(data[key], setting_obj.imageCdnPath);
        }
      });
      const { plugin_html } = this.pluginInfo;
      if (plugin_html) {
        this.plugin_html = xss(plugin_html);
      }
    },
    onCopy() {
      this.$message({
        message: '分享链接已复制，快去分享吧...',
        type: 'success',
      });
    },
    onError() {
      this.$message({
        message: '分享链接复制失败,请手动复制地址栏链接',
        type: 'error',
      });
    },
    like() {
      if (!this.plugin_id || isClick) return;
      isClick = true;
      handlePraise({ res_id: this.plugin_id, res_type: 1, action_type: this.pluginInfo.is_like ? 2 : 1 })
        .then(() => {
          const { plugin_id, plugin_name, is_like } = this.pluginInfo;
          this.pluginInfo.is_like = !is_like;
          this.$sensors.track('like_plugin', {
            action_type: this.pluginInfo.is_like ? 'like' : 'unlike',
            plugin_id,
            plugin_name,
          });
          if (this.pluginInfo.is_like) {
            this.pluginInfo.like_cnt++;
          } else {
            this.pluginInfo.like_cnt--;
          }
          isClick = false;
        })
        .catch(() => {
          isClick = false;
        });
    },
    download() {
      if (!this.plugin_id || this.loading) return;
      this.loading = true;
      downloadApi(this.plugin_id)
        .then(() => {
          handleUserBehaviorByType('plugin');
          this.pluginInfo.is_install = true;
          this.pluginInfo.install_cnt++;
          this.loading = false;
          this.$sensors.track('install_plugin', {
            action_type: 'common',
            plugin_id: this.pluginInfo.plugin_id,
            plugin_name: this.pluginInfo.plugin_name,
            action_position: 'plugin_detail',
          });
          // 根据插件类型显示不同的安装成功提示
          giveInstallMessage(this, this.pluginInfo.editor_type);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goUser() {
      const routeData = this.$router.resolve({
        name: 'profile-id',
        params: { id: this.pluginInfo.author_id },
        query: { tab: 'plugin' },
      });
      window.open(routeData.href, '_blank', 'noopener,noreferrer');
    },
    goTagPage(label) {
      if (!label) return;
      const url = `${window.location.origin}/community/tag/${encodeURIComponent(label)}?cata_name=插件`;
      if (isMobile()) {
        location.href = url;
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
    handleFileSelect(fileId) {
      console.log('Selected file:', fileId);
      this.filePopoverVisible = false;
      // Add actual navigation logic here
    },
    openFileDialog() {
      this.fileDialogVisible = true;
    },
    selectFile(fileId) {
      console.log('Selected file:', fileId);
      this.fileDialogVisible = false;
      // TODO: Implement navigation to the selected file
    },
  },
};
